import * as React from 'react';
import { MenuItem, Paper } from '@material-ui/core';
import { ControllerStateAndHelpers } from 'downshift';
import { ISearchableItem } from './SearchBoxApi';

type ISearchBoxSuggestionProps<T> = {
	items: Array<ISearchableItem<T>>;
	helper: ControllerStateAndHelpers<ISearchableItem<T>>;
	limitSize: number;
	doFilter: boolean;
	searchBoxContainerRef: React.RefObject<any>;
}

export class SearchBoxSuggestions<T> extends React.Component<ISearchBoxSuggestionProps<T>> {

	/**
	 *
	constructor(p: any, c: any) {
		super(p, c);
	}
	*/

	highiLightSearchChars = (word: string, search: string | null) => {
		if (search && word) {
			let index = word.toUpperCase().indexOf(search.toUpperCase());
			return (<span>{word.substring(0, index)}
				<b>{word.substring(index, index + search.length)}</b>
				{word.substring((index + search.length))}</span>);
		} else {
			return <span>{word}</span>
		}
	}



	renderSuggestion = (helper: ControllerStateAndHelpers<ISearchableItem<T>>, suggestion: ISearchableItem<T>, index: number, inputVal: string | null) => {
		const isHighlighted = helper.highlightedIndex === index;
		const isSelected = ((helper.selectedItem && helper.selectedItem.label) || '').indexOf(suggestion.label) > -1;
		return (
			<MenuItem
				{...helper.getItemProps({
					item: suggestion
				})
				}
				style={isSelected ? { fontWeight: "500" } : { fontWeight: "400" }}
				key={`${suggestion.value}_s_${index}`}
				selected={isHighlighted}
				component="div"
			>
				{this.highiLightSearchChars(suggestion.label, inputVal)}
			</MenuItem>
		);
	}

	render() {
		const { items, helper } = this.props;
		let top = this.props.searchBoxContainerRef && this.props.searchBoxContainerRef.current ? this.props.searchBoxContainerRef.current.clientHeight : 50;
		let width = this.props.searchBoxContainerRef && this.props.searchBoxContainerRef.current ? this.props.searchBoxContainerRef.current.clientWidth : "unset";
		return (
			helper.isOpen ?
				(<Paper square
					style={{ top: top, position: "absolute", zIndex: 100, width: width }}  >
					{items
						.map((suggestion, index) =>
							this.renderSuggestion(helper, suggestion, index, helper.inputValue)
						)}
				</Paper>)
				: <div />
		)
	}
}